/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Auth0Client } from "@auth0/auth0-spa-js";

const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID ?? "";
const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN ?? "";
const isTestEnv = navigator.userAgent.includes("jsdom");

// Conditional resolves bug with running tests https://github.com/auth0/auth0-spa-js/issues/522#issuecomment-657440980
const auth0Client = isTestEnv
  ? ({} as Auth0Client)
  : new Auth0Client({
      domain: AUTH0_DOMAIN,
      client_id: AUTH0_CLIENT_ID,
      redirect_uri: window.location.origin,
      cacheLocation: "memory",
    });

(async () => {
  try {
    await auth0Client.checkSession?.();
  } catch {
    auth0Client.logout({
      returnTo: window.location.origin,
    });
  }
})();

export { auth0Client };
